import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components/macro'
import variables from 'core/styles/variables'
import { useRect } from 'core/hooks'
import { CompanyLogo } from 'core/components'
import Icon from 'core/components/Icon'
// this should be portal-ing
// so it doesn't pick up styles from it's react parent

const Wrapper = styled.div`
  margin: 0 !important;
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  padding: 120px 16px;
  overflow-y: auto;
`

const Card = styled.div`
  max-width: 480px;
  background: ${variables.colorWhite};
  box-shadow: ${variables.peachyShadow};
  border-radius: 6px;
  overflow: hidden;
  margin: auto;
`

const CardContents = styled.div`
  padding: ${p => (p.isCompact ? '16px' : '28px 40px')};
`

const LogoArea = styled.div`
  text-align: center;
`

const Contents = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const CloseButton = styled.button`
  color: white;
  position: absolute;
  top: 12px;
  right: 12px;
  padding: 4px 12px;
  background-color: transparent;
  border: none;
  display: inline-block;
  cursor: pointer;
`

const ErrorFooter = styled.div`
  background-color: ${variables.colorRedLighten};
  padding: 8px 24px;
  font-size: 14px;
  color: ${variables.colorBlack80};
`

const OneTimeCodeOverlay = ({ children, errorMessage, onClose }) => {
  const [{ width }, ref] = useRect()

  const isCompact = width < 420

  return (
    <Wrapper>
      <Card ref={ref} isCompact={isCompact}>
        <CardContents>
          <LogoArea>
            <CompanyLogo type='appLargeCentered' />
          </LogoArea>

          <Contents>{children}</Contents>
        </CardContents>

        {errorMessage && <ErrorFooter>{errorMessage}</ErrorFooter>}
      </Card>
      <CloseButton onClick={onClose}>
        <Icon name='clear' inline />
      </CloseButton>
    </Wrapper>
  )
}

OneTimeCodeOverlay.propTypes = {
  errorMessage: PropTypes.string,
  children: PropTypes.node,
  onClose: PropTypes.func
}

export default OneTimeCodeOverlay
